import {
    CContainer,
    CRow,
    CCol,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CButton,
    CFormInput,
    CFormSelect,
} from "@coreui/react";
import React, { useEffect, useContext, useState, useCallback } from "react";
import { CustomBreadcrumbs, PetMemorialsTable } from "../../components";
import { AppContext } from "../../context/AppContext";

const PetMemorials = () => {
    const { getPetMemorials, getPetMemorialStatuses, editPetMemorial } =
        useContext(AppContext);

    const [memorials, setMemorials] = useState([]);
    const [memorialStatuses, setMemorialStatuses] = useState([]);
    const [memorialsPagination, setMemorialsPagination] = useState({});
    const [memorialsPage, setMemorialsPage] = useState(1);
    const [selectedMemorial, setSelectedMemorial] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editData, setEditData] = useState({});

    const memorialsColumns = [
        {
            key: "id",
            label: "ID",
            _props: { scope: "col" },
        },
        {
            key: "pet",
            label: "Mascota",
            _props: { scope: "col" },
        },
        {
            key: "user_name",
            label: "Usuario | Nombre",
            _props: { scope: "col" },
        },
        {
            key: "user_id",
            label: "Usuario | ID",
            _props: { scope: "col" },
        },
        {
            key: "user_email",
            label: "Usuario | email",
            _props: { scope: "col" },
        },
        {
            key: "user_phone_country_code",
            label: "Usuario | C. de País",
            _props: { scope: "col" },
        },
        {
            key: "user_phone_area_code",
            label: "Usuario | C. de Area",
            _props: { scope: "col" },
        },
        {
            key: "user_phone_number",
            label: "Usuario | Teléfono",
            _props: { scope: "col" },
        },
        {
            key: "instragram_handle",
            label: "Instagram",
            _props: { scope: "col" },
        },
        {
            key: "status",
            label: "Estado",
            _props: { scope: "col" },
        },
        {
            key: "actions",
            label: "Acciones",
            _props: { scope: "col" },
        },
    ];

    const fetchMemorials = useCallback(async (page) => {
        const memorialsResponse = await getPetMemorials(page);
        setMemorials(memorialsResponse.data.data);
        setMemorialsPagination(memorialsResponse.data.meta);
    }, []);

    const fetchMemorialStatuses = useCallback(async (page) => {
        const memorialStatusesResponse = await getPetMemorialStatuses();
        setMemorialStatuses(memorialStatusesResponse.data);
    }, []);

    const handlePetMemorialSelected = (id, type) =>{
        const memorial = memorials.find((memorial) => memorial.id === id);
        setSelectedMemorial(memorial);
        if(type === "edit"){
            setEditData({
                instagram_handle: memorial.instagram_handle,
                pet_memorial_status_id: memorial.status.id
            });
            setEditModalVisible(true);
        }
    }

    const goToFirstPageAndRefetch = () => {
        setMemorialsPage(1);
        fetchMemorials(1);
    };

    const handleEditDataChange = (key, value) => {
        setEditData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleEdit = () => {
        editPetMemorial(selectedMemorial.id, editData);
        setEditModalVisible(false);
        goToFirstPageAndRefetch(1);
    };
    
    useEffect(() => {
        fetchMemorials(memorialsPage);
    }, [memorialsPage, fetchMemorials]);

    useEffect(() => {
        fetchMemorialStatuses();
    }, []);

    return (
        <div>
            <CustomBreadcrumbs
                parentTitle={"Usuarios y mascotas"}
                activeTitle="Recuerdos"
            />
            <CContainer>
                <CRow className="justify-content-between">
                    <CCol xs={12}>
                        <h2 className="title">Pedidos de Recuerdo</h2>
                    </CCol>
                </CRow>
                <CRow className="mt-4">
                    {!!memorials.length ? (
                        <PetMemorialsTable
                            columns={memorialsColumns}
                            data={memorials}
                            pagination={memorialsPagination}
                            setFaqsPage={setMemorialsPage}
                            handlePetMemorialSelected={
                                handlePetMemorialSelected
                            }
                        />
                    ) : (
                        <CRow className="justify-content-between mt-4">
                            <CCol xs={12}>
                                <h4>
                                    Todavía no han pedido ningún recuerdo para
                                    un animalito fallecido.
                                </h4>
                            </CCol>
                        </CRow>
                    )}
                </CRow>
            </CContainer>
            {/* Edit Modal */}
            <CModal
                visible={editModalVisible}
                onClose={() => setEditModalVisible(false)}
            >
                <CModalHeader>
                    <CModalTitle>Editar Pedido de Recuerdo</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    {/* Example editable fields using rowData */}
                    <div className="mb-3">
                        <label>Instagram</label>
                        <CFormInput
                            type="text"
                            value={editData.instagram_handle}
                            onChange={(e) =>
                                handleEditDataChange(
                                    "instagram_handle",
                                    e.target.value
                                )
                            }
                        />
                    </div>
                    <div className="mb-3">
                        <label>Estado</label>
                        <CFormSelect
                            id="status"
                            style={{ width: "100%", marginRight: 8 }}
                            onChange={(e) => {
                                handleEditDataChange(
                                    "pet_memorial_status_id",
                                    e.target.value
                                );
                            }}
                            defaultValue={editData?.pet_memorial_status_id}
                        >
                            {memorialStatuses?.map((option, i) => (
                                <option value={option.id} key={i}>
                                    {option.name}
                                </option>
                            ))}
                        </CFormSelect>
                    </div>
                </CModalBody>
                <CModalFooter>
                    <CButton
                        color="secondary"
                        onClick={() => setEditModalVisible(false)}
                    >
                        Close
                    </CButton>
                    <CButton color="primary" onClick={handleEdit}>
                        Guardar Cambios
                    </CButton>
                </CModalFooter>
            </CModal>
        </div>
    );
};

export default PetMemorials;
